import React from "react";
import styles from "./Callus.module.css"

const Callus = () => {
  return (
    <a className={styles.callus} href="tel:12097023370">
      Call (209) 702-3370
    </a>
  );
};


export default Callus